export default __webpack_public_path__ + "static/media/lorem-ipsum.d41cb1a3.pdf";